import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Nav } from 'react-bootstrap';

// Import assets for Footer section
import LogoWhite from '../../assets/logowhite.svg';

function Footer() {
  return (
    <>
      {/* Footer */}
      <footer className="footer">
        <Container>
          <Row className="footer-main align-items-start g-0">
            <Col xs={12} lg="auto" className="footer-brand-bs">
              <div className="footer-title">
                <img src={LogoWhite} alt="Complimate" style={{ height: 50, verticalAlign: 'middle' }} />
              </div>
              <div className="footer-desc">
                <div style={{ marginBottom: '16px', fontSize: '18px', fontWeight: '600', color: '#fff' }}>
                  From audits to policies, tasks, and roles compliance without the guesswork.
                </div>
                <div style={{ fontSize: '16px', color: '#d9d9d9', lineHeight: '1.5' }}>
                  Complimate Built by consultants and frontline teams to make compliance fast, effective, and regulator-ready.
                </div>
              </div>
            </Col>
            <Col xs={12} sm={6} lg className="footer-col-bs footer-col-links">
              <div className="footer-col-title">Quick Links</div>
              <Nav.Link as={Link} to="#features" className="footer-link">Features</Nav.Link>
              <Nav.Link as={Link} to="#pricing" className="footer-link">Pricing</Nav.Link>
              <Nav.Link as={Link} to="#faq" className="footer-link">FAQ</Nav.Link>
            </Col>
            <Col xs={12} sm={6} lg className="footer-col-bs footer-col-legal">
              <div className="footer-col-title">Legal</div>
              <Nav.Link href="http://localhost:3000/privacy" className="footer-link" rel="noopener noreferrer">Privacy Policy</Nav.Link>
              <Nav.Link href="http://localhost:3000/terms" className="footer-link" rel="noopener noreferrer">Terms &amp; Conditions</Nav.Link>
            </Col>
            <Col xs={12} sm={6} lg className="footer-col-bs footer-col-contact">
              <div className="footer-col-title">Contact Us</div>
              <div className="footer-contact-item">
                <span className="footer-contact-label">Email:</span>
                <a href="mailto:support@complimate.com.au" className="footer-contact-link">support@complimate.com.au</a>
              </div>
              <div className="footer-contact-item">
                <span className="footer-contact-label">Phone:</span>
                <a href="tel:1300322050" className="footer-contact-link">1300 32 20 50</a>
              </div>
            </Col>
          </Row>
          <hr className="footer-divider" />
          <Row className="footer-bottom align-items-center">
            <Col xs={12} className="text-center">
              <div className="footer-copyright">© 2025 Complimate. All Rights Reserved.</div>
            </Col>
          </Row>
        </Container>
      </footer>
    </>
  );
}

export default Footer;
